"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackOpenAiAdsConversion } from "./track";

export const OpenAiAdsPageViewTracker = () => {
  const pathname = usePathname();

  useEffect(() => {
    // The pixel sets source_url automatically, but that isn't shown in Ads Manager's event
    // detail view — so also send the path/title here to identify the page in that view.
    trackOpenAiAdsConversion("page_viewed", {
      type: "contents",
      contents: [
        { id: pathname, name: document.title, content_type: "page" },
      ],
    });
    // Re-fire on every route change, not just the first mount.
  }, [pathname]);

  return null;
};



